export default "__VITE_ASSET__7d7f7299__"